import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { formatPhoneNumberIntl } from 'react-phone-number-input';
import _isEmpty from 'lodash/isEmpty';
import Button from 'components/Button';
import { Card } from 'components/Card';
import Message from 'components/Message';
import { bem } from 'helpers/class-name';
import { servicesPropTypes, manageServicesAvailabilityShape } from 'constants/propTypes';
import { AvailabilityDetails } from '../../Components/AvailabilityDetails';
import { messages } from '../Practitioners.messages';
import MissingObjectsCard from '../../Components/MissingObjectsCard/MissingObjectsCard';
import EmptyDetails from '../../EmptyDetails';
import ServicesSummary from '../../Components/ServicesSummary/ServicesSummaryContainer';
import './PractitionerDetails.scss';

const { block, element } = bem('practitioner-details');

const PractitionerDetails = ({ practitioner, handleEditClick }) => {
  const intl = useIntl();
  const isEmpty = _isEmpty(practitioner);
  const { firstName, lastName, email, phone, recurrence, singleDayExceptions, services } = practitioner;
  const fullName = !lastName ? firstName : intl.formatMessage(messages.details.fullName, { firstName, lastName });

  return (
    <Card className={block()} centered={isEmpty}>
      {isEmpty && <EmptyDetails text={messages.details.placeholder} />}
      {!isEmpty && (
        <>
          <div className={element('header', 'grid grid--flush')}>
            <div className="grid__item 9/10 grid grid--flush" data-cypress="practitioner-details-header">
              <span className={element('header-title', 'grid__item 1/1')}>{fullName}</span>
              {email && <span className={element('header-basic', 'grid__item 1/1')}>{email}</span>}
              {phone && (
                <span className={element('header-basic', 'grid__item 1/1')}>{formatPhoneNumberIntl(phone)}</span>
              )}
            </div>
            <div className={element('edit-button', 'grid__item 1/10')}>
              <Message
                as={Button}
                styled={false}
                onClick={handleEditClick}
                message={messages.details.editPractitioner}
                data-cypress="practitioner-edit-button"
              />
            </div>
            {_isEmpty(services) && (
              <MissingObjectsCard
                titleMessage={messages.details.missingObjectsTitle}
                copyMessage={messages.details.missingObjectsCopy}
              />
            )}
          </div>
          <div className="grid grid--flush">
            {(!_isEmpty(recurrence) || !_isEmpty(singleDayExceptions)) && (
              <div className="grid__item 1/1 md-1/2">
                <AvailabilityDetails recurrence={recurrence} singleDayExceptions={singleDayExceptions} />
              </div>
            )}

            <div className="grid__item 1/1 md-1/2">
              <ServicesSummary services={services} />
            </div>
          </div>
        </>
      )}
    </Card>
  );
};

PractitionerDetails.propTypes = {
  practitioner: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    recurrence: manageServicesAvailabilityShape.recurrence,
    singleDayExceptions: manageServicesAvailabilityShape.singleDayExceptions,
    services: servicesPropTypes,
  }),
  handleEditClick: PropTypes.func,
};

export default PractitionerDetails;
